import { AfterViewInit, Component, OnDestroy, OnInit } from '@angular/core';
import { AdobelaunchService } from '../../_services/adobelaunch.service';
import { Store } from '@ngrx/store';
import { selectGroupCode, selectPrfName, selectPrfNumber, selectPrfYear } from 'src/app/store/selectors/app.selector';
import { CompanyService } from '../company.service';
import { combineLatest } from 'rxjs';
import { isLockForValidationSelector, isPrfLocked, validationSummaryJobIdSelector } from '../premiumreport/data-access/premium-report.selectors';
import { Router } from '@angular/router';

@Component({
  selector: 'app-submissioncomplete',
  templateUrl: './submissioncomplete.component.html',
  styleUrls: ['./submissioncomplete.component.scss'],
  standalone: false
})
export class SubmissioncompleteComponent implements OnInit, AfterViewInit, OnDestroy {

  compno: any;
  groupcode: any
  currentYear: number;
  prfNumber: string;
  prfName: string;
  isLocked: boolean;
  isReadOnly: boolean;
  isReadOnlyAdmin: boolean;
  submitted: boolean = false;
  validationJobId: string;
  private lockStatusInterval: any;
  private lockStatusCallCount: number = 0;
  private readonly MAX_LOCK_STATUS_CALLS = 6;

  constructor(private readonly AdobelaunchService: AdobelaunchService, private readonly store: Store, private readonly companyService: CompanyService, private readonly router: Router) { }

  ngOnInit(): void {

    this.store.select(selectPrfName).subscribe(prfName => {
      this.prfName = prfName;
    });

    this.store.select(selectPrfNumber).subscribe(prfNumber => {
      this.prfNumber = prfNumber || '';
      this.compno = prfNumber || '';
    });

    this.store.select(selectPrfYear).subscribe(year => {
      this.currentYear = year;
    });

    this.store.select(selectGroupCode).subscribe(groupCode => {
      this.groupcode = groupCode;
    });

    this.isLocked = this.companyService.isEditLocked;
    this.isReadOnly = this.isLocked || this.isReadOnlyAdmin;

    setTimeout(() => {
      this.getProgress();
    }, 1000);

    combineLatest([
      this.store.select(selectPrfYear),
      this.store.select(selectPrfNumber), 
      this.store.select(selectGroupCode)
    ]).subscribe(([year, prfNumber, groupCode]) => {
      if (year && prfNumber && groupCode && !this.lockStatusInterval) {
        console.log('Starting getLockStatus interval every 2 seconds...');

        this.lockStatusInterval = setInterval(() => {
          if (this.lockStatusCallCount >= this.MAX_LOCK_STATUS_CALLS) {
            this.clearLockStatusInterval();
            return;
          }

          this.lockStatusCallCount++;

          this.companyService.getLockStatus(year, prfNumber, groupCode).subscribe({
            next: (response: any) => {
              const newSubmittedStatus = response.result.lock_for_validation == false && response.result.status == 'Locked';
              this.submitted = newSubmittedStatus;
              if (this.submitted) {
                this.clearLockStatusInterval();
              }
            },
            error: (error) => {
              console.error('getLockStatus error:', error);
            }
          });
        }, 2000);
      }
    });

    combineLatest([
      this.store.select(isLockForValidationSelector),
      this.store.select(isPrfLocked),
      this.store.select(validationSummaryJobIdSelector)
    ]).subscribe(([isValidationLocked, prfLocked, validationJobId]) => {
      this.submitted = isValidationLocked == false && prfLocked == true;
      this.validationJobId = validationJobId;
    });

  }

  getProgress() {

    this.companyService.getCustomerPrfProgress(this.currentYear, this.compno, this.groupcode).subscribe({
      next: (resp) => {
        if (resp["message"] == "Success") {
          this.companyService.groupreportingInProgress.next(true);
        }
      },
      error: (error) => {

      }
    })


  }

  ngAfterViewInit() {
    this.AdobelaunchService.EventEndDispatch();
  }

  ngOnDestroy() {
    this.clearLockStatusInterval();
  }

  private clearLockStatusInterval() {
    if (this.lockStatusInterval) {
      console.log(`Clearing getLockStatus interval after ${this.lockStatusCallCount} calls`);
      clearInterval(this.lockStatusInterval);
      this.lockStatusInterval = null;
      this.lockStatusCallCount = 0;
    }
  }
   navigateToSubmissionSummary() {
    this.router.navigate([
      `/${this.currentYear}/${encodeURIComponent(
        this.prfNumber
      )}/PRFsubmissionreportsummary`,
    ]);
  }
}
